var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEyeHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5585 9.8005C8.00499 13.2871 4.10475 18.2849 1.68515 22.1616C-0.56432 25.7657 -0.564322 30.2375 1.68515 33.8416C5.82758 40.4785 14.3098 50.4016 27.9981 50.4016C35.9345 50.4016 42.1208 47.0658 46.7258 42.9689L42.4766 38.7195C38.7381 41.9566 33.9411 44.4016 27.9981 44.4016C17.5231 44.4016 10.608 36.8057 6.7751 30.6647C5.73903 29.0047 5.73903 26.9984 6.7751 25.3384C9.21185 21.4343 12.8944 16.9421 17.9454 14.1876L13.5585 9.8005ZM22.1825 18.4247C18.9528 20.3888 16.7977 23.9411 16.7977 28.0008C16.7977 34.1906 21.8153 39.2008 27.9977 39.2008C32.0573 39.2008 35.6094 37.0458 37.5736 33.8163L33.0393 29.2819C32.47 31.5366 30.4316 33.2008 27.9977 33.2008C25.1264 33.2008 22.7977 30.8743 22.7977 28.0008C22.7977 25.5668 24.4619 23.5284 26.7167 22.9591L22.1825 18.4247ZM29.0968 16.8539L39.1446 26.902C38.6284 21.5903 34.4085 17.3703 29.0968 16.8539ZM46.6125 34.3701C47.6025 33.1245 48.4708 31.8667 49.2211 30.6647C50.2572 29.0047 50.2572 26.9984 49.2211 25.3384C45.3882 19.1974 38.4731 11.6016 27.9981 11.6016C26.6725 11.6016 25.4038 11.7232 24.1912 11.9482L19.2869 7.0437C21.9167 6.13755 24.8168 5.60156 27.9981 5.60156C41.6864 5.60156 50.1686 15.5246 54.311 22.1616C56.5605 25.7657 56.5605 30.2375 54.311 33.8416C53.3857 35.3241 52.2439 36.9705 50.8759 38.6337L46.6125 34.3701Z",
    fill: "#38A6D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3L52.8004 52.8004",
    stroke: "#38A6D5",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeHide);
export default __webpack_public_path__ + "static/media/icon-eye-hide.1d10b247e779859077225ba631c820a0.svg";
export { ForwardRef as ReactComponent };